module.exports = __webpack_public_path__ + "static/img/egg_r_20.58e9afc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/r/egg_r_20.png
// module id = Ob40
// module chunks = 1